<div class="card">
    <div class="card-body">
        <div class="d-flex">
            <div>
                <h3 class="card-title">SMS/Calls</h3>
                <h6 class="card-subtitle text-muted">Manage your SMS/Call settings.</h6>
            </div>
            <button type="button" class="btn ms-auto my-auto" [class.btn-primary]="isCommunicationsActive" [class.btn-danger]="!isCommunicationsActive" (click)="toggleEnableSms();">
                <fa-icon [icon]="isCommunicationsActive ? faToggleOn : faToggleOff"></fa-icon>
            </button>
        </div>
    </div>
</div>
<div class="mt-2">
    @switch (subAccountDetails?.status) {
        @case("REGISTRATION") {
            <app-settings-communications-registration [subAccountDetails]="subAccountDetails" (refreshSubaccountDetails)="getTwilioSubaccountSettings();"></app-settings-communications-registration>
        }
        @case("PENDING_REVIEW") {
            <ngb-alert [dismissible]="false">
                <strong>Your application has been submitted for review.</strong> Please check back later for status updates.
            </ngb-alert>
        }
        @case("ACTIVE") {
            <app-settings-communications-active [subAccountDetails]="subAccountDetails" (refreshSubaccountDetails)="getTwilioSubaccountSettings();"></app-settings-communications-active>
        }
    }
</div>